import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Shield, Star, CheckCircle2 } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-8 md:pt-12 pb-10 md:pb-20 px-4 overflow-hidden bg-[#0F172A] bg-field-pattern" data-id="element-175">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-176">
        {/* H1 - Main Title */}
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="font-display text-3xl sm:text-5xl md:text-6xl text-white leading-[0.95] mb-6 md:mb-8 uppercase" data-id="element-177">
          Todo tu año de <br className="hidden sm:block" data-id="element-178" />
          entrenamiento de <span className="text-cancha" data-id="element-179">Futsal</span>{' '}
          <span className="text-gold" data-id="element-180">Resuelto</span>
        </motion.h1>

        {/* Mockup Image - 70% sized */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="relative w-full max-w-[70%] sm:max-w-[60%] md:max-w-[55%] mb-2 md:mb-3" data-id="element-181">
          <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full transform scale-90" data-id="element-182"></div>
          <img src="https://cdn.magicpatterns.com/uploads/w4Pjng3VTn4ByNxyiXj4gx/mockup.png" alt="Megapack DT Futsal - Mockup del producto" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-183" />
        </motion.div>

        {/* Subtitle Paragraph */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-base md:text-lg text-gray-300 mb-6 md:mb-8 font-medium leading-relaxed max-w-2xl mt-4" data-id="element-184">
          Tu sistema completo de entrenamiento amateur listo: mentalidad,
          planificación, táctica, evaluación, gestión del grupo y herramientas
          listas para usar.{' '}
          <strong className="text-white" data-id="element-185">Sin improvisar más.</strong>
        </motion.p>

        {/* CTA */}
        <motion.button initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} onClick={scrollToPricing} className="w-full sm:w-auto bg-cancha hover:bg-cancha-dark text-white font-bold text-base md:text-lg px-6 md:px-10 py-3.5 md:py-4 rounded-xl shadow-[0_6px_0_#064E2B] md:shadow-[0_8px_0_#064E2B] hover:shadow-[0_3px_0_#064E2B] md:hover:shadow-[0_4px_0_#064E2B] hover:translate-y-1 transition-all flex items-center justify-center gap-2 mb-5 md:mb-6" data-id="element-186">
          <span data-id="element-187">💥 QUIERO MI FUTSAL RESUELTO AHORA</span>
        </motion.button>

        {/* Trust row */}
        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-xs md:text-sm font-semibold text-gray-300 mb-3 md:mb-4" data-id="element-188">
          <div className="flex items-center gap-1" data-id="element-189">
            <FileText size={14} className="text-gold" data-id="element-190" /> PDF Digital
          </div>
          <div className="w-1 h-1 rounded-full bg-gray-600" data-id="element-191"></div>
          <div className="flex items-center gap-1" data-id="element-192">
            <Zap size={14} className="text-gold" data-id="element-193" /> Acceso Inmediato
          </div>
          <div className="w-1 h-1 rounded-full bg-gray-600" data-id="element-194"></div>
          <div className="flex items-center gap-1" data-id="element-195">
            <Shield size={14} className="text-gold" data-id="element-196" /> Entrenador Amateur
          </div>
        </div>

        {/* Social proof */}
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-[11px] md:text-xs font-medium text-gray-400 bg-gray-900 px-3 md:px-4 py-2 md:py-3 rounded-lg border border-gray-800" data-id="element-197">
          <div className="flex items-center gap-1" data-id="element-198">
            <UsersIcon data-id="element-199" /> +500 Entrenadores
          </div>
          <div className="flex items-center gap-1 text-gold" data-id="element-200">
            <Star size={12} fill="currentColor" data-id="element-201" /> 4.9 Rating
          </div>
          <div className="flex items-center gap-1" data-id="element-202">🇦🇷 Todo Argentina</div>
          <div className="flex items-center gap-1" data-id="element-203">
            <Shield size={12} data-id="element-204" /> Garantía 7 días
          </div>
        </div>
      </div>
    </section>;
}
function UsersIcon() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-205">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" data-id="element-206" />
      <circle cx="9" cy="7" r="4" data-id="element-207" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" data-id="element-208" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-209" />
    </svg>;
}